"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _Text = _interopRequireDefault(require("../Text/Text"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconChevronRight = function IconChevronRight(props) {
  return (0, _themeUi.jsx)("svg", props, (0, _themeUi.jsx)("path", {
    d: "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
  }));
};

IconChevronRight.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512"
};

var ButtonListItem = function ButtonListItem(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "disabled"]);

  return (0, _themeUi.jsx)("button", _extends({}, props, {
    disabled: disabled,
    type: "button",
    sx: _extends({
      variant: 'buttons.Button.text',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      py: 2,
      px: 3,
      minHeight: 5,
      color: 'text'
    }, !disabled && {
      cursor: 'pointer',
      '&:hover': {
        '& svg': {
          transform: function transform(theme) {
            return "translateX(" + theme.space[2] + "px)";
          }
        }
      }
    }, {
      pointerEvents: disabled ? 'none' : 'auto'
    })
  }), (0, _themeUi.jsx)(_themeUi.Box, {
    sx: {
      flexGrow: 1,
      textAlign: 'left'
    }
  }, (0, _themeUi.jsx)(_Text["default"], {
    sx: {
      display: 'block'
    }
  }, children)), (0, _themeUi.jsx)(_themeUi.Box, {
    sx: {
      flexGrow: 0,
      flexShrink: 0
    }
  }, (0, _themeUi.jsx)(_Icon["default"], {
    icon: IconChevronRight,
    sx: {
      transition: "transform 250ms ease",
      color: 'inherit'
    }
  })));
};

ButtonListItem.propTypes = {
  children: _propTypes["default"].node,
  disabled: _propTypes["default"].bool
};
ButtonListItem.defaultProps = {
  children: null,
  disabled: false
};
var _default = ButtonListItem;
exports["default"] = _default;